import { useDecision } from '@optimizely/react-sdk';
import { FeatureFlag } from 'enums';

function withMfaFeatureFlag<T>(
  MfaComponent: React.ComponentType<T>
): React.ComponentType<T> {
  const AugmentedComponent = (props: T): JSX.Element => {
    const [mfaFlag] = useDecision(FeatureFlag.EnableSelectiveMFA, {
      autoUpdate: true,
    });

    return <>{mfaFlag.enabled && <MfaComponent {...(props as T)} />}</>;
  };

  return AugmentedComponent;
}

export { withMfaFeatureFlag };
